(function () {
    'use strict';

    var $ = window.jQuery;

    function SlideMenu(options) {
        if (!options) {
            throw new Error('No options passed to SlideMenu constructor');
        }
        this.options = $.extend({}, SlideMenu.defaults, options);
        if (!this.options.toggler) {
            throw new Error('No toggler passed to SlideMenu constructor');
        }
        this.setupSlideMenu();
    }

    SlideMenu.prototype.setupSlideMenu = function () {
        $(this.options.navbarId).on('click', this.options.toggler, $.proxy(function (e, el) {
            var selected = $(this.options.toggler).hasClass('slide-active');

            if (selected === false) {
                $(document).trigger('mobile_menu.opening');
            } else {
                $(document).trigger('mobile_menu.closing');
            }

            $(this.options.toggler).toggleClass(this.options.slideActiveClass, !selected);
            $(this.options.menuContainer).toggleClass(this.options.slideActiveClass);

            $(this.options.pageWrapper + ',' + this.options.navbarId + ', body,' + this.options.navigationWrapper).toggleClass('slide-active');

            $(this.options.toggler).toggleClass('collapsed');

            $(this.options.menuContainer)
                .stop()
                .animate({
                    left: selected ? this.options.menuNeg : '0px'
                }, 400, function () {
                    if (selected === false) {
                        $(document).trigger('mobile_menu.opened');
                    } else {
                        $(document).trigger('mobile_menu.closed');
                    }
                });
            $(this.options.navbarHeightCol).stop().animate({
                left: selected ? this.options.slideNeg : '0px'
            });

            $(this.options.pageWrapper).stop().animate({
                left: selected ? '0px' : this.options.slideWidth
            });

            $(this.options.navigationWrapper).stop().animate({
                left: selected ? '0px' : this.options.slideWidth,
                "margin-left": selected ? '-15px' : '9px'
            });
        }, this));
    };

    SlideMenu.defaults = {
        navbarId: '#bordeaux-top-menu',
        navbarHeightCol: '#navbar-height-col',
        toggler: '.navbar-toggle',
        navigationWrapper: '.navbar-header',
        slideActiveClass: 'slide-active',
        pageWrapper: '#wrapper',
        menuContainer: '#main-menu-container',
        menuWidth: '100%',
        slideWidth: '80%',
        menuNeg: '-100%',
        slideNeg: '-80%',
    };

    window.SlideMenu = SlideMenu;
}())
;